import React, { useEffect, useState } from "react";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {
  Button,
  ButtonGroup,
  Checkbox,
  Chip,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Input,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Stack,
} from "@mui/material";
import Paper from "@mui/material/Paper";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import personIcon from "../../images/person.svg";
import { authHeader } from "../comman/MainFunction";
import {
  UPSERT_CUSTOMERS_URL,
  GET_CUSTOMER_BY_ID_URL,
} from "../../constants/ApiRoute";
import {
  CUSTOMERS_ROUTE,
  DASHBOARD_ROUTE,
  PAGE_NOT_FOUND_PATH,
} from "../../constants/RoutePath";
import * as Yup from "yup";
import { useFormik } from "formik";
import API from "../comman/API";
import { useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import EmailSchema from "../comman/validation/EmailSchema";
import { useToast } from "../comman/CustomMessages";
import Navbar from "../comman/Navbar";
import { pageTypeList } from "../comman/Constant";
import {
  allowedCharactersRegex,
  phoneNumberRegex,
} from "../comman/RegexConstant";
import { useSelector, useDispatch } from "react-redux";
import { getAllStatesList } from "../../redux/action";
import CustomPageLoading from "../comman/CustomPageLoading";

const initialValues = {
  userId: 0,
  name: "",
  active: true,
  defaultDayRate: "",
  billingPeriod: "",
  contactFirstName: "",
  contactLastName: "",
  contactEmail: "",
  contactOfficePhone: "",
  contactMobilePhone: "",
  paStreet1: "",
  paStreet2: "",
  paCity: "",
  paState: "",
  paZip: "",
  baStreet1: "",
  baStreet2: "",
  baCity: "",
  baState: "",
  baZip: "",
  isCheckBoxEnabled: 0,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const CustomerDetails = () => {
  const pathname = window.location.pathname;
  const parts = pathname.split("/");
  const id = parts[parts.length - 1];
  const cleanId = id.split("%")[0];

  const [physicalTobillingAddress, setPhysicalTobillingAddress] =
    useState(false);
  const [customerName, setCustomerName] = useState("");
  const [editFlag, setFlag] = useState(true);
  const [pageType, setPageType] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const showToast = useToast();
  const navigate = useNavigate();
  const stateList = deCryptFun(useSelector((s) => s.AllStateListReducer));

  const validationSchema = Yup.object({
    name: Yup.string()
      .trim()
      .required("Customer name is required")
      .min(1, "Customer name must be at least 1 character")
      .max(100, "Customer name cannot exceed 100 characters"),
    defaultDayRate: Yup.string().required("Default day rate is required"),
    billingPeriod: Yup.number()
      .required("Billing period is required")
      .min(1, "Billing period must be at least 1 day")
      .max(31, "Billing period cannot exceed 31 days")
      .typeError("Billing period is should be number"),
    contactFirstName: Yup.string()
      .trim()
      .required("First name is required")
      .matches(
        allowedCharactersRegex,
        "First name should only contain alphabetic characters"
      )
      .min(1, "First name must be at least 1 character")
      .max(50, "First name cannot exceed 50 characters"),
    contactLastName: Yup.string()
      .trim()
      .required("Last name is required")
      .matches(
        allowedCharactersRegex,
        "Last name should only contain alphabetic characters"
      )
      .min(1, "Last name must be at least 1 character")
      .max(50, "Last name cannot exceed 50 characters"),
    contactEmail: EmailSchema.required("Email is required"),
    paStreet1: Yup.string()
      .trim()
      .required("Street 1 is required")
      .min(3, "Street 1 must be at least 3 character")
      .max(100, "Street 1 cannot exceed 100 characters"),
    baStreet1: Yup.string()
      .trim()
      .required("Street 1 is required")
      .min(3, "Street 1 must be at least 3 character")
      .max(100, "Street 1 cannot exceed 100 characters"),
    baZip: Yup.string()
      .required("Zipcode is required")
      .matches(/\d$/, "Zipcode must be a valid format")
      // .matches(phoneNumberRegex, "Zipcode should only contain numbers")
      .min(5, "Zipcode must be at least 5 digits long")
      .max(10, "Zipcode cannot exceed 10 digits long"),
    paZip: Yup.string()
      .required("Zipcode is required")
      .matches(/\d$/, "Zipcode must be a valid format")
      // .matches(phoneNumberRegex, "Zipcode should only contain numbers")
      .min(5, "Zipcode must be at least 5 digits long")
      .max(10, "Zipcode cannot exceed 10 digits long"),
    paCity: Yup.string()
      .trim()
      .required("City is required")
      .min(3, "City must be at least 3 character")
      .max(50, "City cannot exceed 50 characters"),
    baCity: Yup.string()
      .trim()
      .required("City is required")
      .min(3, "City must be at least 3 character")
      .max(50, "City cannot exceed 50 characters"),
  });

  const formatPhoneNumber = (value) => {
    // Remove non-numeric characters
    const cleaned = ("" + value).replace(/\D/g, "");
    const match = cleaned.match(/(\d{3})(\d{3})(\d{4})/);

    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return value;
  };

  const editFun = () => {
    setFlag(!editFlag);
    setPageType(pageTypeList[2].edit);
  };
  const handlecancel = () => {
    if (pageType == pageTypeList[2].edit) {
      getCustomerByDetails();
    }
    setFlag(!editFlag);
  };
  const {
    handleSubmit,
    handleChange,
    setValues,
    values,
    errors,
    setErrors,
    touched,
    resetForm,
  } = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      updateCustomer(values);
    },
  });

  console.log(values,'hsjkhasuieiyiu')

  const updateCustomer = async () => {
    setLoading(true);
    const config = {
      method: "POST",
      url: UPSERT_CUSTOMERS_URL,
      headers: authHeader(),
      data: {
        webString: enCryptFun(JSON.stringify(values)),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (parsedResponse.status === "Success") {
        setCustomerName(values.name);
      setFlag(true);

        showToast("Customer updated successfully", "success");
        getCustomerByDetails()
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
      // getCustomerByDetails();

    }
  };

  const [physicalAddress, setPhysicalAddress] = React.useState({
    paStreet1: "",
    paStreet2: "",
    paCity: "",
    paState: "",
    paZip: "",
  });

  const handlePAadressChange = (e) => {
    const { name, value } = e.target;

    var trimmedValue = "";

    if (name === "paState" || name === "baState") {
      trimmedValue = value;
    } else {
      if (value.startsWith(" ")) {
        trimmedValue = value.trimStart();
      } else {
        trimmedValue = value;
      }
    }

    setPhysicalAddress({
      ...physicalAddress,
      [name]: trimmedValue,
    });
    setValues((prevValues) => ({
      ...prevValues,
      [name]: trimmedValue,
    }));
  };

  const handleChangeValidateSpace = (event) => {
    const { name, value } = event.target;
    var trimmedValue = "";
    if (name === "paState" || name === "baState") {
      trimmedValue = value;
    } else {
      if (value.startsWith(" ")) {
        trimmedValue = value.trimStart();
      } else {
        trimmedValue = value.replace(/\s+/g, '');
      }
    }

    setValues({
      ...values,
      [name]: trimmedValue,
    });
  };

  const handleBothAdressIsEqual = () => {
    if (
      (values.paStreet1 ||
        values.paCity ||
        values.paZip ||
        values.paState ||
        values.paZip) &&
      values.paStreet1 == values.baStreet1 &&
      values.paStreet2 == values.baStreet2 &&
      values.paCity == values.baCity &&
      values.paState == values.baState &&
      values.paZip == values.baZip
    ) {
      setPhysicalTobillingAddress(true);
    } else {
      setPhysicalTobillingAddress(false);
    }
  };

  const handleChangeName = (event) => {
    const { name, value } = event.target;
    // var trimmedValue = "";

    // Trim leading spaces
    const trimmedValue = value.trimStart();

    // Validate that trimmed value only contains alphabets and is up to 50 characters long
    if (/^[A-Za-z\s]*$/.test(trimmedValue) && trimmedValue.length <= 50) {
      setValues({ ...values, [name]: trimmedValue });
    }
  };

  const handleChangeStreet = (event) => {
    const { name, value } = event.target;
    // setIsProjectFormUpdated(true);
    var trimmedValue = "";

    if (value.startsWith(" ")) {
      trimmedValue = value.trimStart();
    } else {
      trimmedValue = value;
    }

    if (trimmedValue.length <= 250) {
      setValues({ ...values, [name]: trimmedValue });
      setPhysicalAddress({
        ...physicalAddress,
        [name]: trimmedValue,
      });
    }
  };

  const handleChangeCity = (event) => {
    const { name, value } = event.target;
    // setIsProjectFormUpdated(true);
    var trimmedValue = "";

    if (value.startsWith(" ")) {
      trimmedValue = value.trimStart();
    } else {
      trimmedValue = value;
    }

    if (trimmedValue.length <= 50) {
      setValues({ ...values, [name]: trimmedValue });
      setPhysicalAddress({
        ...physicalAddress,
        [name]: trimmedValue,
      });
    }
  };

  const handleChangeZipcode = (event) => {
    const { name, value } = event.target;

    // Ensure the value does not exceed the maximum length
    if (value.length > 10) {
      return; // Prevent state update if length exceeds 10
    }

    // Validate that the value starts with a number
    if (value.length > 0 && !/^\d/.test(value)) {
      return; // Prevent state update if it doesn't start with a number
    }

    // Ensure the value contains only numbers and at most one hyphen
    const sanitizedValue = value.replace(/[^0-9\-]/g, ""); // Remove any non-numeric and non-hyphen characters
    const hyphenCount = (sanitizedValue.match(/-/g) || []).length;

    if (hyphenCount > 1) {
      return; // Prevent state update if more than one hyphen is present
    }

    setValues({ ...values, [name]: sanitizedValue });
    setPhysicalAddress({
      ...physicalAddress,
      [name]: sanitizedValue,
    });
  };

  const handleCustmerName = (event) => {
    const { name, value } = event.target;
    //setIsProjectFormUpdated(true);

    var trimmedValue = value;

    if (value.startsWith(" ")) {
      trimmedValue = value.trimStart();
    }

    // Regex to check for valid input: letters, numbers, and spaces
    // const regex = /^[a-zA-Z0-9 ]+$/;
    //const regex = /^[a-zA-Z0-9 ]*$/

    // Check if the trimmed value is betweens 1 and 50 characters and matches the regex
    if (trimmedValue.length <= 100) {
      setValues({ ...values, [name]: trimmedValue });
    }
  };

  const handleChangeCustom = (event) => {
    const { name, value } = event.target;
    const intValue = value.replace(/[^\d]/g, "").slice(0, 10); // Limit to 10 digits
    setValues({ ...values, [name]: intValue });
  };
  

  const handleChangeBillingPeriods = (event) => {
    const { name, value } = event.target;
    // setIsProjectFormUpdated(true);
    const intValue = value.replace(/[^\d]/g, "");
    const sanitizedValue =
      intValue === "" ? "" : Math.min(parseInt(intValue), 31).toString();

    // Ensure that the sanitized value is not "0"
    const finalValue = sanitizedValue === "0" ? "" : sanitizedValue;

    setValues({ ...values, [name]: finalValue });
  };

  // const handleChangeDecimalValue = (event) => {
  //   const { name, value } = event.target;
  //   const sanitizedValue = value.replace(/[^\d.]/g, "");
  //   if ((sanitizedValue.match(/\./g) || []).length > 1) {
  //     return;
  //   }

  //   if (/^0[0-9]+/.test(sanitizedValue)) {
  //     const correctedValue = sanitizedValue.replace(/^0+/, "");
  //     setValues({ ...values, [name]: correctedValue });
  //     return;
  //   }

  //   const decimalParts = sanitizedValue.split(".");
  //   if (decimalParts[1] && decimalParts[1].length > 2) {
  //     return;
  //   }

  //   setValues({ ...values, [name]: sanitizedValue });
  // };
  const handleChangeDecimalValue = (event) => {
    const { name, value } = event.target;

    // Handle empty value
    if (value === "") {
      setValues({ ...values, [name]: value });
      return;
    }

    // Allow only valid float values with up to 2 decimal places
    const floatRegex = /^\d*\.?\d{0,2}$/;

    // Check if the value matches the float regex and is within the limit
    if (floatRegex.test(value)) {
      const numericValue = parseFloat(value);

      // Ensure the numeric value is not greater than 10,000 or empty
      if (value === "" || !isNaN(numericValue)) {
        setValues({ ...values, [name]: value });
      }
    }
  };

  const physicalTobillingAddressOnchange = () => {
    setPhysicalTobillingAddress(!physicalTobillingAddress);

    if (!physicalTobillingAddress) {
      setValues((prevValues) => ({
        ...prevValues,
        baStreet1: physicalAddress.paStreet1 ? physicalAddress.paStreet1 : "",
        baStreet2: physicalAddress.paStreet2 ? physicalAddress.paStreet2 : "",
        baCity: physicalAddress.paCity ? physicalAddress.paCity : "",
        baState: physicalAddress.paState ? physicalAddress.paState : "",
        baZip: physicalAddress.paZip ? physicalAddress.paZip : "",
        isCheckBoxEnabled: 1,
      }));
    } else {
      setValues((prevValues) => ({
        ...prevValues,
        baStreet1: "",
        baStreet2: "",
        baCity: "",
        baState: "",
        baZip: "",
        isCheckBoxEnabled: 0,
      }));
    }
  };

  const getCustomerByDetails = async () => {
    setLoading(true);
    const config = {
      method: "GET",
      url: GET_CUSTOMER_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify({ userId: cleanId })),
        flutterString: "",
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);

      if (parsedResponse.status == "Success") {
        const {
          UserId,
          Name,
          DefaultDayRate,
          BillingPeriod,
          PAStreet1,
          PAStreet2,
          PACity,
          PAState,
          PAZip,
          BAStreet1,
          BAStreet2,
          BACity,
          BAState,
          BAZip,
          ContactFirstName,
          ContactLastName,
          ContactEmail,
          ContactOfficePhone,
          ContactMobilePhone,
          Active,
          IsCheckBoxEnabled,
        } = parsedResponse.data[0];

        setCustomerName(Name);
        setValues({
          userId: UserId,
          name: Name,
          active: Active,
          defaultDayRate: DefaultDayRate?.toFixed(2),
          billingPeriod: BillingPeriod,
          contactFirstName: ContactFirstName,
          contactLastName: ContactLastName,
          contactEmail: ContactEmail,
          contactOfficePhone: ContactOfficePhone,
          contactMobilePhone: ContactMobilePhone,
          paStreet1: PAStreet1,
          paStreet2: PAStreet2,
          paCity: PACity,
          paState: PAState,
          paZip: PAZip,
          baStreet1: BAStreet1 ? BAStreet1 : "", 
          baStreet2: BAStreet2 ? BAStreet2 : "",
          baCity: BACity ? BACity : "",
          baState: BAState ? BAState : "  ",
          baZip: BAZip,
          isCheckBoxEnabled: IsCheckBoxEnabled,
        });

        setPhysicalTobillingAddress(IsCheckBoxEnabled);

        setPhysicalAddress({
          paStreet1: PAStreet1,
          paStreet2: PAStreet2,
          paCity: PACity,
          paState: PAState,
          paZip: PAZip,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        showToast(v.message, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (cleanId && editFlag) {
      getCustomerByDetails();
    }
  }, [cleanId]);

  useEffect(() => {
    dispatch(getAllStatesList());
  }, [dispatch]);

  useEffect(() => {
    handleBothAdressIsEqual();
  }, [
    values.paStreet1,
    values.paStreet2,
    values.paCity,
    values.paState,
    values.paZip,
    values.baStreet1,
    values.baStreet2,
    values.baCity,
    values.baState,
    values.baZip,
  ]);

  const valuer = localStorage.getItem("DASHBOARD_NAVI");
  const BackFun = () => {
    if (valuer) {
      navigate(DASHBOARD_ROUTE);
      localStorage.removeItem("DASHBOARD_NAVI");
    } else {
      navigate(CUSTOMERS_ROUTE);
    }
  };

  // useEffect(() => {
  //   // console.log(id.length, "biddddddddddd");
  //   // Check if bid is a number and has more than 3 digits
  //   if (!(/^\d*$/).test(id)) {
  //     // If bid is invalid (e.g., less than 4 digits), redirect to the dashboard
  //     navigate(PAGE_NOT_FOUND_PATH, { replace: true });
  //   }
  // }, [id, navigate]);
  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"1"} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar
            title={values && values.name}
            backFlag={true}
            backRoute={valuer ? DASHBOARD_ROUTE : CUSTOMERS_ROUTE}
          />
          <Box className="bg-box user-log">
            <Stack
              sx={{ mb: 2 }}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Typography className="customer-title">
                Customer Details
              </Typography>
              {/* <Button
                  className="edit-btn"
                  variant="outlined"
                  startIcon={
                    <span class="material-symbols-outlined">Save</span>
                  }
                  type="submit"
                >
                  Save
                </Button> */}

              {loading && <CustomPageLoading />}

              <Stack direction="row" spacing={1} justifyContent="flex-end">
                {editFlag == true ? (
                  <Button
                    className="edit-btn"
                    variant="outlined"
                    startIcon={
                      <span className="material-symbols-outlined">Edit</span>
                    }
                    type="submit"
                    onClick={editFun}
                  >
                    Edit
                  </Button>
                ) : (
                  <>
                    <Button
                      className="primary-btn"
                      variant="outlined"
                      type="submit"
                      color="success"
                      onClick={handleSubmit}
                    >
                      Save
                    </Button>
                  </>
                )}
                {!editFlag && pageType != pageTypeList[0].add && (
                  //    {pageType === pageTypeList[2].edit
                  // ||
                  //  pageType === pageTypeList[1].list
                  // ?
                  <Button
                    className="cancel-btn"
                    variant="contained"
                    type="submit"
                    onClick={handlecancel}
                    // disabled={!editFlag}
                  >
                    Cancel
                  </Button>
                )}
              </Stack>
            </Stack>
            <Box className="user-details-form">
              <Stack
                className="user-details-form"
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">Customer Name:</p>
                  <Input
                    name="name"
                    id="name"
                    value={values.name}
                    onChange={handleCustmerName}
                    disabled={editFlag}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name ? errors.name : ""}
                    placeholder="Enter Customer Name"
                  />
                  <FormHelperText error={true}>
                    {errors.name && touched.name ? errors.name : ""}
                  </FormHelperText>
                </FormControl>

                <Box sx={{ width: "100%" }}>
                  <p className="label">Status:</p>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={2}
                  >
                    <FormControlLabel
                      className="checkbox"
                      control={
                        <Checkbox
                          name="active"
                          id="activeYes"
                          disabled={editFlag}
                          onChange={() =>
                            setValues({ ...values, active: true })
                          }
                          sx={{ color: "gray" }}
                          checked={values.active == true}
                        />
                      }
                      label="Active"
                    />

                    <FormControlLabel
                      className="checkbox"
                      control={
                        <Checkbox
                          name="active"
                          id="activeNo"
                          disabled={editFlag}
                          onChange={() =>
                            setValues({ ...values, active: false })
                          }
                          sx={{ color: "gray" }}
                          checked={values.active == false}
                        />
                      }
                      label="Inactive"
                    />
                  </Stack>
                </Box>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">Billing Default Day Rate:</p>
                  <Input
                    className="dollar-field"
                    name="defaultDayRate"
                    id="defaultDayRate"
                    value={values.defaultDayRate}
                    onChange={handleChangeDecimalValue}
                    disabled={editFlag}
                    startAdornment={
                      <InputAdornment position="start">
                        <span className="dollar-icon">$</span>
                      </InputAdornment>
                    }
                    error={errors.defaultDayRate && touched.defaultDayRate}
                    helperText={
                      errors.defaultDayRate && touched.defaultDayRate
                        ? errors.defaultDayRate
                        : ""
                    }
                    placeholder="Enter Billing Day Rate"
                  />
                  <FormHelperText error={true}>
                    {errors.defaultDayRate && touched.defaultDayRate
                      ? errors.defaultDayRate
                      : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">Billing Default Period (in days):</p>
                  <Input
                    name="billingPeriod"
                    id="billingPeriod"
                    value={values.billingPeriod}
                    onChange={handleChangeBillingPeriods}
                    disabled={editFlag}
                    error={errors.billingPeriod && touched.billingPeriod}
                    helperText={
                      errors.billingPeriod && touched.billingPeriod
                        ? errors.billingPeriod
                        : ""
                    }
                    placeholder="Enter Billing Default Period"
                  />
                  <FormHelperText error={true}>
                    {errors.billingPeriod && touched.billingPeriod
                      ? errors.billingPeriod
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
            </Box>

            <Typography className="customer-title">
              Contact Information
            </Typography>

            <Box className="user-details-form">
              <Stack
                className="user-details-form"
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">First Name:</p>
                  <Input
                    name="contactFirstName"
                    id="contactFirstName"
                    value={values.contactFirstName}
                    disabled={editFlag}
                    onChange={handleChangeName}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.contactFirstName && touched.contactFirstName}
                    helperText={
                      errors.contactFirstName && touched.contactFirstName
                        ? errors.contactFirstName
                        : ""
                    }
                    placeholder="Enter First Name"
                  />
                  <FormHelperText error={true}>
                    {errors.contactFirstName && touched.contactFirstName
                      ? errors.contactFirstName
                      : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="standard">
                  <p className="label">Last Name:</p>
                  <Input
                    name="contactLastName"
                    id="contactLastName"
                    value={values.contactLastName}
                    disabled={editFlag}
                    onChange={handleChangeName}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.contactLastName && touched.contactLastName}
                    helperText={
                      errors.contactLastName && touched.contactLastName
                        ? errors.contactLastName
                        : ""
                    }
                    placeholder="Enter Last Name"
                  />
                  <FormHelperText error={true}>
                    {errors.contactLastName && touched.contactLastName
                      ? errors.contactLastName
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">Email:</p>
                  <Input
                    name="contactEmail"
                    id="contactEmail"
                    value={values.contactEmail}
                    disabled={editFlag}
                    onChange={handleChangeValidateSpace}
                    startAdornment={
                      <InputAdornment position="start">
                        <span class="material-symbols-outlined">mail</span>
                      </InputAdornment>
                    }
                    error={errors.contactEmail && touched.contactEmail}
                    helperText={
                      errors.contactEmail && touched.contactEmail
                        ? errors.contactEmail
                        : ""
                    }
                    placeholder="Enter Email"
                  />
                  <FormHelperText error={true}>
                    {errors.contactEmail && touched.contactEmail
                      ? errors.contactEmail
                      : ""}
                  </FormHelperText>
                </FormControl>
                <FormControl variant="standard">
                  <p className="label">Office Phone:</p>
                  <Input
                    name="contactOfficePhone"
                    id="contactOfficePhone"
                    value={formatPhoneNumber(values.contactOfficePhone)}
                    disabled={editFlag}
                    onChange={handleChangeCustom}
                    startAdornment={
                      <InputAdornment position="start">
                        <span class="material-symbols-outlined">call</span>
                        <span className="country-code">+1</span>
                      </InputAdornment>
                    }
                    error={
                      errors.contactOfficePhone && touched.contactOfficePhone
                    }
                    helperText={
                      errors.contactOfficePhone && touched.contactOfficePhone
                        ? errors.contactOfficePhone
                        : ""
                    }
                    placeholder="Enter Office Phone Number"
                  />
                  <FormHelperText error={true}>
                    {errors.contactOfficePhone && touched.contactOfficePhone
                      ? errors.contactOfficePhone
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                spacing={{ xs: 2, sm: 4, md: 7 }}
                sx={{ width: { xs: "100%", md: "47.5%" } }}
              >
                <FormControl variant="standard">
                  <p className="label">Mobile Phone:</p>
                  <Input
                    name="contactMobilePhone"
                    id="contactMobilePhone"
                    value={formatPhoneNumber(values.contactMobilePhone)}
                    disabled={editFlag}
                    onChange={handleChangeCustom}
                    startAdornment={
                      <InputAdornment position="start">
                        <span class="material-symbols-outlined">call</span>
                        <span className="country-code">+1</span>
                      </InputAdornment>
                    }
                    error={
                      errors.contactMobilePhone && touched.contactMobilePhone
                    }
                    helperText={
                      errors.contactMobilePhone && touched.contactMobilePhone
                        ? errors.contactMobilePhone
                        : ""
                    }
                    placeholder="Enter Mobile Phone Number"
                  />
                  <FormHelperText error={true}>
                    {errors.contactMobilePhone && touched.contactMobilePhone
                      ? errors.contactMobilePhone
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
            </Box>

            <Typography className="customer-title">Physical Address</Typography>

            <Box className="user-details-form">
              <Stack
                className="user-details-form"
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">Street 1:</p>
                  <Input
                    name="paStreet1"
                    id="paStreet1"
                    value={values.paStreet1}
                    disabled={editFlag}
                    onChange={handleChangeStreet}
                    error={errors.paStreet1 && touched.paStreet1}
                    helperText={
                      errors.paStreet1 && touched.paStreet1
                        ? errors.paStreet1
                        : ""
                    }
                    placeholder="Enter Street 1"
                  />
                  <FormHelperText error={true}>
                    {errors.paStreet1 && touched.paStreet1
                      ? errors.paStreet1
                      : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="standard">
                  <p className="label">Street 2:</p>
                  <Input
                    name="paStreet2"
                    id="paStreet2"
                    value={values.paStreet2}
                    disabled={editFlag}
                    onChange={handleChangeStreet}
                    error={errors.paStreet2 && touched.paStreet2}
                    helperText={
                      errors.paStreet2 && touched.paStreet2
                        ? errors.paStreet2
                        : ""
                    }
                    placeholder="Enter Street 2"
                  />
                  <FormHelperText error={true}>
                    {errors.paStreet2 && touched.paStreet2
                      ? errors.paStreet2
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">City:</p>
                  <Input
                    name="paCity"
                    id="paCity"
                    value={values.paCity}
                    disabled={editFlag}
                    onChange={handleChangeCity}
                    error={errors.paCity && touched.paCity}
                    helperText={
                      errors.paCity && touched.paCity ? errors.paCity : ""
                    }
                    placeholder="Enter City"
                  />
                  <FormHelperText error={true}>
                    {errors.paCity && touched.paCity ? errors.paCity : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="outlined">
                  <p className="label">State:</p>
                  <Select
                    sx={{
                      // Style for select component
                      "& .MuiSelect-select": {
                        color: values.paState ? "#212121" : "#898989",
                      },
                      // Placeholder styles
                      "& .MuiSelect-select::before": {
                        color: "#212121", // Placeholder color
                        content: "attr(data-placeholder)",
                      },
                    }}
                    name="paState"
                    displayEmpty
                    value={values.paState ? values.paState : ""}
                    disabled={editFlag}
                    IconComponent={KeyboardArrowDownIcon}
                    onChange={handlePAadressChange}
                    error={errors.paState && touched.paState}
                    helperText={
                      errors.paState && touched.paState ? errors.paState : ""
                    }
                  >
                    <MenuItem disabled value="">
                      Select State
                    </MenuItem>
                    {stateList &&
                      JSON.parse(stateList).data.map((item) => (
                        <MenuItem key={item.countyId} value={item.countyId}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText error={true}>
                    {errors.paState && touched.paState ? errors.paState : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                spacing={{ xs: 2, sm: 4, md: 7 }}
                sx={{ width: { xs: "100%", md: "47.5%" } }}
              >
                <FormControl variant="standard">
                  <p className="label">Zipcode:</p>
                  <Input
                    name="paZip"
                    id="paZip"
                    value={values.paZip}
                    disabled={editFlag}
                    onChange={handleChangeZipcode}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.paZip && touched.paZip}
                    helperText={
                      errors.paZip && touched.paZip ? errors.paZip : ""
                    }
                    placeholder="Enter Zipcode"
                  />
                  <FormHelperText error={true}>
                    {errors.paZip && touched.paZip ? errors.paZip : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
            </Box>

            <Typography
              sx={{ mb: "0px !important" }}
              className="customer-title"
            >
              Billing Address
            </Typography>

            <Box>
              <Stack sx={{ mb: "25px !important" }} direction="row">
                <FormControlLabel
                  className="checkbox"
                  control={
                    <Checkbox
                      id="physicalTobillingAddress"
                      disabled={editFlag}
                      onChange={physicalTobillingAddressOnchange}
                      sx={{ color: "gray" }}
                      checked={physicalTobillingAddress}
                    />
                  }
                  label="Save physical address as my billing address."
                />
              </Stack>
            </Box>

            <Box className="user-details-form">
              <Stack
                className="user-details-form"
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">Street 1:</p>
                  <Input
                    name="baStreet1"
                    id="baStreet1"
                    value={values.baStreet1}
                    disabled={editFlag}
                    onChange={handleChangeStreet}
                    error={errors.baStreet1 && touched.baStreet1}
                    helperText={
                      errors.baStreet1 && touched.baStreet1
                        ? errors.baStreet1
                        : ""
                    }
                    placeholder="Enter Street 1"
                  />
                  <FormHelperText error={true}>
                    {errors.baStreet1 && touched.baStreet1
                      ? errors.baStreet1
                      : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="standard">
                  <p className="label">Street 2:</p>
                  <Input
                    name="baStreet2"
                    id="baStreet2"
                    value={values.baStreet2}
                    disabled={editFlag}
                    onChange={handleChangeStreet}
                    error={errors.baStreet2 && touched.baStreet2}
                    helperText={
                      errors.baStreet2 && touched.baStreet2
                        ? errors.baStreet2
                        : ""
                    }
                    placeholder="Enter Street 2"
                  />
                  <FormHelperText error={true}>
                    {errors.baStreet2 && touched.baStreet2
                      ? errors.baStreet2
                      : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 4, md: 7 }}
                alignItems="center"
              >
                <FormControl variant="standard">
                  <p className="label">City:</p>
                  <Input
                    name="baCity"
                    id="baCity"
                    value={values.baCity}
                    disabled={editFlag}
                    onChange={handleChangeCity}
                    error={errors.baCity && touched.baCity}
                    helperText={
                      errors.baCity && touched.baCity ? errors.baCity : ""
                    }
                    placeholder="Enter City"
                  />
                  <FormHelperText error={true}>
                    {errors.baCity && touched.baCity ? errors.baCity : ""}
                  </FormHelperText>
                </FormControl>

                <FormControl variant="outlined">
                  <p className="label">State:</p>
                  <Select
                    sx={{
                      // Style for select component
                      "& .MuiSelect-select": {
                        color: values.baState ? "#212121" : "#898989",
                      },
                      // Placeholder styles
                      "& .MuiSelect-select::before": {
                        color: "#212121", // Placeholder color
                        content: "attr(data-placeholder)",
                      },
                    }}
                    name="baState"
                    displayEmpty
                    value={values.baState ? values.baState : ""}
                    disabled={editFlag}
                    onChange={handleChangeValidateSpace}
                    IconComponent={KeyboardArrowDownIcon}
                    error={errors.baState && touched.baState}
                    helperText={
                      errors.baState && touched.baState ? errors.baState : ""
                    }
                  >
                    <MenuItem disabled value="">
                      Select State
                    </MenuItem>
                    {stateList &&
                      JSON.parse(stateList).data.map((item) => (
                        <MenuItem key={item.countyId} value={item.countyId}>
                          {item.name}
                        </MenuItem>
                      ))}
                  </Select>
                  <FormHelperText error={true}>
                    {errors.baState && touched.baState ? errors.baState : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
              <Stack
                direction="row"
                alignItems="center"
                spacing={{ xs: 2, sm: 4, md: 7 }}
                sx={{ width: { xs: "100%", md: "47.5%" } }}
              >
                <FormControl variant="standard">
                  <p className="label">Zipcode:</p>
                  <Input
                    name="baZip"
                    id="baZip"
                    value={values.baZip}
                    disabled={editFlag}
                    onChange={handleChangeZipcode}
                    startAdornment={
                      <InputAdornment position="start">
                        <img src={personIcon} />
                      </InputAdornment>
                    }
                    error={errors.baZip && touched.baZip}
                    helperText={
                      errors.baZip && touched.baZip ? errors.baZip : ""
                    }
                    placeholder="Enter Zipcode"
                  />
                  <FormHelperText error={true}>
                    {errors.baZip && touched.baZip ? errors.baZip : ""}
                  </FormHelperText>
                </FormControl>
              </Stack>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CustomerDetails;
